import axios from 'axios'

export let fetchOrders = async ({limit, offset, q, dateStart, dateEnd}) => {
  let res = await axios.get(
    'return/orders?limit=' + limit + '&offset=' + offset + '&q=' + q + '&dateStart=' + dateStart + '&dateEnd=' + dateEnd)

  return res.data
}

export let create = async (data) => {
  let res = await axios.post('return/create', data)

  return res.data
}

export let fetchHistory = async (data) => {
  let res = await axios.get('return/history')

  return res.data
}

export let setTrackNumber = async (id, trackNumber) => {
  await axios.post('return/track', {id, trackNumber})
}



// WEBPACK FOOTER //
// ./src/api/return.js